import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  ChartData,
  LinearScale,
  Tooltip,
} from 'chart.js';
import dynamic from 'next/dynamic';

const Bar = dynamic(() => import('react-chartjs-2').then((mod) => mod.Bar), {
  ssr: false,
});

Chart.register(ArcElement, Tooltip, CategoryScale, LinearScale, BarElement);

export const AgeBarChart = ({ data }: { data: ChartData<'bar'> }) => {
  return (
    <Bar
      data={data}
      options={{
        aspectRatio: 1.25,
        scales: {
          x: {
            stacked: true,
            grid: {
              color: '#fff',
            },
          },
          y: {
            stacked: true,
            grid: {
              tickBorderDash: [8, 4],
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return ' ' + tooltipItem.formattedValue + '%';
              },
            },
          },
        },
        responsive: true,
        animation: false,
      }}
    />
  );
};
